import { useCallback } from 'react';

import { useLocale } from 'hooks/useLocale';

type TranslatedTextFragment = {
  en?: string | undefined;
  ar?: string | undefined;
};

export const useTranslatedText = () => {
  const { locale } = useLocale();
  return useCallback(
    (text?: TranslatedTextFragment) => text?.[locale] ?? '',
    [locale],
  );
};
